import { isFieldVisible } from "../../../../../../utils/form";
import TextInput from "../../../../../../components/TextInput";
import MetricInput from "../../../../../../components/MetricInput";
import SelectInputFromForm from "../../../../../../components/SelectInputFromForm";
import MultipleChoiceInput from "../../../../../../components/MultipleChoiceInput";
import TypologiesInput from "../../../../../../components/TypologiesInput";
import { Fragment } from "react/jsx-runtime";
import Tooltip from "../../../../../../components/Tooltip";
import DatePickerInput from "../../../../../../components/DatePickerInput";
import ImageUpload from "../../../../../../components/ImageUpload";
import FieldCard from "../../../../../../components/FieldCard";

interface Props {
  form: any;
  values: any;
  setValues: any;
  handleFormItem: any;
}

export function FormFields(props: Props) {
  const { form, values, handleFormItem } = props;

  return form?.campos?.map((item: any) => {
    if (item.component === "ScoreCalculator" && !item.ShowOnForm) {
      return null;
    }

    if (item.component === "CalculoAutomatico" && !item.ShowField) {
      return null;
    }

    const currentValue = values[item.chave || item.Chave];
    const tooltip = item.Tooltip;
    const showTooltip = !!item.MostrarTooltip;

    if (item.component === "Separador") {
      const centerText = !!item.Centralizar;
      const isSubtitle = !!item.Subtitulo;
      const description = item.Descricao;
      return (
        <div key={`separator-${item._uid}`} className="pt-2">
          <div
            className={`flex items-center ${
              centerText ? "justify-center" : "justify-start"
            } ${isSubtitle ? "px-2" : ""}`}
          >
            {showTooltip && tooltip && <Tooltip tooltip={tooltip} />}
            <p
              className={`font-medium text-gray ${
                centerText ? "text-center" : ""
              } ${!isSubtitle ? "text-xl" : "text-lg"} ${
                !description ? "font-medium" : "font-bold"
              }`}
            >
              {item.Titulo}
            </p>
          </div>

          {description && (
            <p
              className={`mt-1 text-sm text-muted ${
                centerText ? "text-center" : ""
              }`}
            >
              {description}
            </p>
          )}
        </div>
      );
    }

    const isVisible = isFieldVisible(item, values);
    if (!isVisible) {
      return null;
    }

    const itemKey = item.type || item.chave || item.Chave;

    const inputs = {
      "Texto Livre": (
        <TextInput
          placeholder="Insira um texto livre…"
          onChange={(e) => handleFormItem(e.target.value, itemKey)}
          variant="outlined"
          value={values[itemKey] ?? ""}
        />
      ),
      Número: (
        <TextInput
          placeholder="Insira um valor numérico…"
          inputMode="decimal"
          onChange={(e) =>
            handleFormItem(
              e.target.value
                ?.replace(",", ".")
                ?.replace(/[^0-9.]+/g, "")
                ?.replace(/(\..*)\./g, "$1"),
              itemKey
            )
          }
          variant="outlined"
          value={values[itemKey] ?? ""}
        />
      ),
      Metrica: (
        <MetricInput
          id={itemKey}
          options={item.opcoes}
          value={values[itemKey]}
          handleFormItem={handleFormItem}
        />
      ),
      Seleção: (
        <SelectInputFromForm
          id={itemKey}
          value={values[itemKey] ?? ""}
          options={item.valores?.map((item: any) => item.nome.trim())}
          onChange={(e) => handleFormItem(e.target.value, itemKey)}
        />
      ),
      Multiplaescolha: (
        <MultipleChoiceInput
          item={item}
          allowMultiple={!!item.PermitirMultiplasSelecoes}
          handleFormItem={handleFormItem}
          value={values[itemKey]}
          options={item.valores?.map((item: any) => item.nome.trim())}
        />
      ),
      Midia: (
        <ImageUpload
          id={itemKey}
          value={values[itemKey]}
          handleFormItem={handleFormItem}
        />
      ),
      DataInput: (
        <DatePickerInput
          id={itemKey}
          handleFormItem={handleFormItem}
          value={values[itemKey]}
        />
      ),
      Tipologias: (
        <TypologiesInput
          item={item}
          value={currentValue}
          handleFormItem={handleFormItem}
        />
      ),
      CalculoAutomatico: (
        <p className="font-semibold tabular-nums text-gray">
          {item.nome}{" "}
          {typeof currentValue !== "undefined" ? currentValue : "0"}
          {item.Tipo === "percent" ? "%" : ""}
        </p>
      ),
      MultiplaescolhaAutomatica: (
        <MultipleChoiceInput
          item={item}
          handleFormItem={handleFormItem}
          value={values[itemKey]}
          options={item.valores?.map((item: any) => item.nome.trim())}
          disabled
        />
      ),
    };

    if (item.component === "Tipologias") {
      return (
        <Fragment key={item._uid}>
          <div className="flex items-center gap-1">
            <p className="font-medium text-gray">
              {item.nome || item.Nome}
              {item.obrigatorio && (
                <span className="text-red" aria-hidden="true">{` *`}</span>
              )}
            </p>
            {showTooltip && tooltip && <Tooltip tooltip={tooltip} />}
          </div>
          {inputs.Tipologias}
        </Fragment>
      );
    }

    return (
      <FieldCard key={item._uid}>
        <div className="mb-2 flex items-center gap-1">
          <p className="font-semibold text-gray">
            {item.nome || item.Nome}
            {item.obrigatorio && (
              <span className="text-red" aria-hidden="true">{` *`}</span>
            )}
          </p>
          {showTooltip && tooltip && <Tooltip tooltip={tooltip} />}
        </div>

        {inputs[item.component as keyof typeof inputs]}
      </FieldCard>
    );
  });
}
